module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/Item/images/icon-gold.0a63b9d3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/Item/images/icon-gold.png
// module id = 3073
// module chunks = 11